import React, { Component } from 'react'
import moment from "moment";
import { Link } from 'react-router-dom'
import log from '../../../helpers/logger'
import { auth, getCurrentUser } from '../../../helpers/auth'
import { getTimeStamp, getUUIDV4 } from '../../../helpers/utils'
import {
  createIssue,
  updateIssue,
  getIssue,
  deleteIssue } from '../../../services/IssueService'

function setErrorMsg(error) {
  return {
    errorMsg: error.message
  }
}

export default class IssuePageView extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMsg: null,
      currentUser: null,
      isLoading: true,
      issueId: null,
      issue: null
    };

    this.handleDelete = this.handleDelete.bind(this);
  }

  componentWillMount() {
    log.debug('componentWillMount')
  }
  async componentDidMount(){
    log.debug('componentDidMount')
    let user = await getCurrentUser();
    this.setState({currentUser: user})

    log.debug(this.props.match.params)
    // load info
    let issue = await getIssue(this.props.match.params.id)
    log.debug(issue)

    log.debug('all data is loaded.')
    this.setState({issueId: this.props.match.params.id})
    this.setState({issue: issue})
    this.setState({isLoading: false})
  }

  async handleDelete(issueId, e) {
    e.preventDefault()
    log.debug(issueId)
    var r = window.confirm("Confirm to delete.");
    if (r == true) {
        log.debug('do delete')
        try{
          await deleteIssue(issueId)
          log.debug('delete success.')

          this.state.issue.status = 'D'
          this.setState({issue: this.state.issue})
        }catch(err){
          log.debug(err)
          this.setState(setErrorMsg(err))
        }

    } else {
        log.debug('delete cancel')
    }
  }

  render () {

    let content;

    if (this.state.isLoading) {
      content = <div>Loading...</div>;
    } else {
      content =
      <div>
        <h4 className="page-header">
          <Link to='/issue'>Issue</Link> ->
          View
        </h4>
        <div className="panel panel-default">
    <div className="panel-heading">
        <Link className="btn btn-success" to={`/issue/edit/${this.state.issueId}`}>Edit</Link>
        &nbsp;
        <button
          type="button"
          onClick={(e) => this.handleDelete(this.state.issueId, e)}
          className="btn btn-small btn-danger">Delete</button>

          <br /><br />
          <Link className="btn btn-success" to={`/upload-book-cover/${this.state.issueId}`}>Upload Book Cover</Link>
          &nbsp;
          <Link className="btn btn-success" to={`/file_cover_url_list/issue/${this.state.issueId}`}>Book Cover List</Link>

          <br /><br />
          <Link className="btn btn-success" to={`/upload-book-zip/${this.state.issueId}`}>Upload Book Zip</Link>
          &nbsp;
          <Link className="btn btn-success" to={`/file_book_download_url_list/issue/${this.state.issueId}`}>Book Zip List</Link>

    </div>
    {/* /.panel-heading */}
    <div className="panel-body">
        <div className="table-responsive">
            <table className="table table-striped table-bordered table-hover">
                <thead>
                    <tr>
                        <th style={{width: '20%'}}>Name</th>
                        <th>value</th>
                    </tr>
                </thead>
                <tbody>
                  <tr>
                      <td>issue_id</td>
                      <td>{this.state.issueId}</td>
                  </tr>

                    <tr>
                        <td>issue_uuid</td>
                        <td>{this.state.issue.issue_uuid}</td>
                    </tr>

                    <tr>
                        <td>magazine_id</td>
                        <td>{this.state.issue.magazine_id}</td>
                    </tr>

                    <tr>
                        <td>magazine_uuid</td>
                        <td>{this.state.issue.magazine_uuid}</td>
                    </tr>

                    <tr>
                        <td>owner_id</td>
                        <td>{this.state.issue.owner_id}</td>
                    </tr>

                    <tr>
                        <td>tag</td>
                        <td>{this.state.issue.tag}</td>
                    </tr>

                    <tr>
                        <td>title</td>
                        <td>{this.state.issue.title}</td>
                    </tr>

                    <tr>
                        <td>description</td>
                        <td>{this.state.issue.description}</td>
                    </tr>

                    <tr>
                        <td>is_publish</td>
                        <td>{this.state.issue.is_publish}</td>
                    </tr>

                    <tr>
                        <td>issue_version</td>
                        <td>{this.state.issue.issue_version}</td>
                    </tr>

                    <tr>
                        <td>cover_width</td>
                        <td>{this.state.issue.cover_width}</td>
                    </tr>

                    <tr>
                        <td>cover_height</td>
                        <td>{this.state.issue.cover_height}</td>
                    </tr>

                    <tr>
                        <td>cover_url</td>
                        <td>{this.state.issue.cover_url}</td>
                    </tr>

                    <tr>
                        <td>issue_download_url</td>
                        <td>{this.state.issue.issue_download_url}</td>
                    </tr>

                    <tr>
                        <td>download_success_msg_title</td>
                        <td>{this.state.issue.download_success_msg_title}</td>
                    </tr>

                    <tr>
                        <td>download_success_msg_body</td>
                        <td>{this.state.issue.download_success_msg_body}</td>
                    </tr>

                    <tr>
                        <td>notify_cover_number</td>
                        <td>{this.state.issue.notify_cover_number}</td>
                    </tr>

                    <tr>
                        <td>share_text</td>
                        <td>{this.state.issue.share_text}</td>
                    </tr>

                    <tr>
                        <td>embed_html</td>
                        <td>{this.state.issue.embed_html}</td>
                    </tr>

                    {/* <tr>
                        <td>date_released</td>
                        <td>{this.state.issue.date_released}</td>
                    </tr>

                    <tr>
                        <td>date_modified</td>
                        <td>{this.state.issue.date_modified}</td>
                    </tr> */}

                    <tr>
                        <td>date_created</td>
                        <td>{moment(this.state.issue.date_created).format('DD/MM/YYYY, h:mm:ss')}</td>
                    </tr>

                    <tr>
                        <td>status</td>
                        <td>{this.state.issue.status}</td>
                    </tr>


                    {/* <tr>
                        <td>date_created</td>
                        <td>{moment(this.state.issue.date_created).format('DD/MM/YYYY, h:mm:ss')}</td>
                    </tr> */}

                </tbody>
            </table>
        </div>
        {/* /.table-responsive */}
    </div>
    {/* /.panel-body */}
</div>
      </div>
    }


    return (
      <div>
          {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/IssuePage/IssuePageView.js